(() => {
  const selector = document.querySelector('[data-kp-market-selector]');
  if (!selector) return;

  const storageKey = 'kokkopris-market-selector-v1';
  const params = new URLSearchParams(window.location.search);
  const forcedOpen = params.get('kp_market') === 'open';
  const confirmedArrival = params.get('kp_market') === 'confirmed';
  const designMode = selector.dataset.designMode === 'true';
  const dialog = selector.querySelector('[role="dialog"]');
  const form = selector.querySelector('form');
  const countrySelect = selector.querySelector('select[name="country_code"]');
  const submitButton = selector.querySelector('[data-kp-market-submit]');
  const closeButtons = selector.querySelectorAll('[data-kp-market-close]');
  const openButtons = document.querySelectorAll('[data-kp-market-selector-open]');
  let lastOpenButton = null;

  const rememberChoice = () => {
    try {
      window.localStorage.setItem(storageKey, 'confirmed');
    } catch (error) {
      // The selector still works when storage is unavailable.
    }
  };

  const hasRememberedChoice = () => {
    try {
      return window.localStorage.getItem(storageKey) === 'confirmed';
    } catch (error) {
      return false;
    }
  };

  const cleanControlParameter = () => {
    params.delete('kp_market');
    const query = params.toString();
    const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
    window.history.replaceState({}, '', cleanUrl);
  };

  const closeSelector = () => {
    rememberChoice();
    selector.hidden = true;
    document.body.classList.remove('kp-market-selector-open');
    if (lastOpenButton) lastOpenButton.focus();
  };

  const openSelector = () => {
    selector.hidden = false;
    document.body.classList.add('kp-market-selector-open');
    window.requestAnimationFrame(() => countrySelect.focus());
  };

  if (confirmedArrival) {
    rememberChoice();
    cleanControlParameter();
    return;
  }

  if (forcedOpen) cleanControlParameter();

  if (!designMode && (forcedOpen || !hasRememberedChoice())) {
    window.setTimeout(openSelector, 250);
  }

  closeButtons.forEach((button) => button.addEventListener('click', closeSelector));
  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      lastOpenButton = button;
      openSelector();
    });
  });

  selector.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSelector();
  });

  form.addEventListener('submit', () => {
    rememberChoice();
    submitButton.disabled = true;
    submitButton.textContent = 'Bytter butikk …';
  });
})();
